<template>
    <div class="payment-success-popup">
        <BaseModalWithLogo class="payment-success-popup__container">
            <img class="payment-success-popup__image"
                src="@/assets/graphic-high-five.svg" />
            <span class="payment-success-popup__title">
                Payment successful
            </span>
            <span class="payment-success-popup__description">
                Your account has been upgraded to {{ planName }}. You’ll be receiving an email shortly with purchase details.
            </span>
            <BaseButton class="payment-success-popup__button"
                button-style="dark-gray"
                button-size="large"
                @click="handleProceed">
                Let's Proceed!
            </BaseButton>
            <span class="payment-success-popup__order-number"
                v-if="orderNumber">
                Order # {{ orderNumber }}
            </span>
        </BaseModalWithLogo>
    </div>
</template>

<script>
import BaseModalWithLogo from '@/common/BaseModalWithLogo'

export default {
    name: 'PaymentSuccessPopup',
    components: {
        BaseModalWithLogo
    },
    props: {
        planName: {
            type: String,
            required: true
        },
        orderNumber: {
            type: String,
            required: true
        }
    },
    methods: {
        handleProceed() {
            this.$emit('proceed')
        }
    }
}
</script>

<style lang="scss" scoped>
.payment-success-popup {
    &__container {
        padding: 36px 48px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
    }

    &__title {
        font-size: 28px;
        font-weight: 600;
        color: $rfx-text-dark-high-contrast;
    }

    &__description {
        font-size: 20px;
        line-height: 150%;
        color: $rfx-text-dark-mid-contrast;
        text-align: center;
    }

    &__button {
        font-size: 20px;
        margin-top: 16px;
    }

    &__order-number {
        display: block;
        padding: 12px 0;
        text-align: center;
        font-size: 14px;
        color: $rfx-text-dark-mid-contrast;
    }
}
</style>